import * as _ from 'lodash';
import { PaymentConfig } from 'src/app/app.interfaces';
import { CreditCard } from 'src/app/shared/classes/credit-card/credit-card.class';
import { PaymentsConfig } from 'src/app/shared/classes/projects/payments/payments-config.class';
import { FormatCurrencyPipe } from 'src/app/shared/common/pipes/format-currency.pipe';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { PaymentsListItem } from 'src/app/shared/modules/sidebar/booking-detail/payments-list/payments-list.interfaces';
import { ITranslations, Translations } from 'src/app/shared/utils/translations';

export class PaymentTemplate {
  private _currency: string;
  private _currencyBuyer: string;
  private _creditCard: CreditCard;
  private _payment: PaymentsListItem;
  private _payments: PaymentsListItem[];
  private _bk: string;
  private _mcp: PaymentConfig['mcp'];
  private _config: PaymentsConfig['config'];
  private _translations: ITranslations;

  public description: string;
  public title: string;

  constructor() {
    const {
      booking: {
        creditCard,
        resume: { payments, currency, currencyBuyer, paymentConfig },
        bk
      },
      project,
      ...rest
    } = InjectorService.get().get(ConfigService);
    const _payments = [...(_.get(payments, 'paymentsDetail', [])), ...(_.get(payments, 'deposit', []))];

    Object.assign(this, {
      _creditCard: creditCard,
      _currency: currency,
      _currencyBuyer: currencyBuyer,
      _config: _.get(rest[project], 'config.config'),
      _payments,
      _payment: _payments.find((p: PaymentsListItem) => p.selected),
      _bk: bk,
      _mcp: paymentConfig.mcp
    });

    this.getTranslations();
  }

  public get creditCard(): CreditCard {
    return this._creditCard;
  }

  public get payment(): PaymentsListItem {
    return this._payment;
  }

  public get config(): PaymentsConfig['config'] {
    return this._config;
  }

  public get payments(): PaymentsListItem[] {
    return this._payments;
  }

  public get bk(): string {
    return this._bk;
  }

  public get currency(): string {
    return this._currency;
  }

  public get currencyBuyer(): string {
    return this._currencyBuyer;
  }

  public getAmountTranslation(): string {
    const { amount, currency } = this._getPayment();

    return `${InjectorService.get().get(FormatCurrencyPipe).transform(amount, currency)}`;
  }

  public _getPayment(): any {
    if (this._mcp.enabled) {
      return {
        amount: this.payment.mcp.amount,
        currency: this.payment.mcp.currency
      };
    }

    return {
      amount: this.payment.amount,
      currency: this.payment.currency
    };
  }

  private getTranslations(): void {
    new Translations([
      'payment-error-title',
      'payment-success-title',
      'payment-success-description',
      'payment-new-charge',
      'payment-add-card',
      'payment-add-card-description',
      'payment-new-charge-amount',
      'payment-new-charge-amount-portal',
      'payment-new-charge-detail',
      'payment-new-charge-change-card',
      'purchase-credit-card-error-description',
      'purchase-credit-card-error-description-portal',
      'payment-new-charge-amount-ideal',
      'payment-new-charge-amount-sofort',
      'purchase-ideal-error-description',
      'purchase-ideal-error-description-portal',
      'purchase-sofort-error-description',
      'purchase-sofort-error-description-portal',
      'detailed-payment-success-title',
      'detailed-payment-success-description',
      'deposit-payment',
      'deposit',
      'payment.one',
      'payment-new-charge-amount-redirect',
      'payment-new-charge-redirect',
      'purchase-redirect-error-description',
      'purchase-redirect-error-description-portal',
      'payment.one',
      'payment-new-charge-deposit',
      'detailed-deposit-success-description',
      'card-hold'
    ]).get((translations: ITranslations) => {
      this._translations = translations;

      this.onTranslations(translations);
    });
  }

  public refreshTranslations(): void {
    this.onTranslations(this._translations);
  }

  public onTranslations(translations: ITranslations): void {
    throw new Error('onTranslations must be implemented');
  }
}
